import { gql } from "@apollo/client";

export const UPDATE_STATUS = gql`
  mutation updateOrderStatus($id: ID, $transactionId: ID, $status: String!) {
    updateOrderStatus(input: {
      id: $id,
      transactionId: $transactionId,
      status: $status
    }) {
      statusCode
      message
    }
  }
`
